import requests from './httpService';

const ImagesStoreService = {
  createImagesStore(body) {
    return requests.post('/imagesstore/add', body);
  },
  findImagesStoreList(body) {
    return requests.post('/imagesstore/find', body);
  },
  getImagesStoreById(id) {
    return requests.get(`/imagesstore/${id}`);
  },
  updateImagesStore(id, body) {
    return requests.put(`/imagesstore/${id}`, body);
  },
  deleteImagesStore(id) {
    return requests.delete(`/imagesstore/${id}`);
  },

  /**
   * Upload multiple images in one request (multipart field "images").
   * Uses shared credentialed axios client (HttpOnly cookie session).
   */
  uploadImagesBatch(formData, onSendProgress) {
    return requests.post('/imagesstore/uploadimages', formData, {
      onUploadProgress: (event) => {
        if (!onSendProgress || !event.total) return;
        onSendProgress({
          phase: 'sending',
          loaded: event.loaded,
          total: event.total,
          percent: Math.min(100, Math.round((event.loaded * 100) / event.total)),
        });
      },
    });
  },

  uploadMedia(formData, onSendProgress) {
    return requests.post('/imagesstore/uploadmedia', formData, {
      onUploadProgress: (event) => {
        if (!onSendProgress || !event.total) return;
        onSendProgress({
          phase: 'sending',
          loaded: event.loaded,
          total: event.total,
          percent: Math.min(100, Math.round((event.loaded * 100) / event.total)),
        });
      },
    });
  },

  getUploadProgress(uploadId) {
    return requests.get(`/imagesstore/uploadprogress/${uploadId}`);
  },

  deleteAzureImage(body) {
    return requests.post('/imagesstore/deleteazureimage', body);
  },
};

export default ImagesStoreService;
